import React from "react";
import { LINKS } from "@/lib/links";

// Wordmark + logo image
export const RimMark = ({ variant = "dark", className = "", size = "md" }) => {
  const textColor = variant === "dark" ? "text-white" : "text-rim-ink";
  const sizes = {
    sm: { box: "h-7 w-7", text: "text-base" },
    md: { box: "h-9 w-9", text: "text-lg" },
    lg: { box: "h-11 w-11", text: "text-xl" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <a
      href="#top"
      data-testid="brand-logo"
      className={`group inline-flex items-center gap-2.5 ${className}`}
      aria-label="Rimfluences — Home"
    >
      <span
        className={`${s.box} rounded-xl bg-white grid place-items-center overflow-hidden ring-1 ring-black/5 shadow-sm`}
      >
        <img
          src={LINKS.logo}
          alt="Rimfluences"
          className="h-full w-full object-cover"
          loading="eager"
        />
      </span>
      <span
        className={`font-heading font-semibold tracking-tight ${s.text} ${textColor}`}
      >
        Rimfluences
      </span>
    </a>
  );
};

export default RimMark;
